module.exports = __webpack_public_path__ + "img/4.244d718f.png";